import React, { Component } from 'react';
import { logInfo } from '../../utils/utils';
import { Header } from '..'
import { BrowserRouter, Routes, Route } from 'react-router-dom';

export default class AuthPage extends Component {
  constructor(props) {
    super(props);

    this.sideNavBarRef = React.createRef();
  }

  render() {
    return (
      <div>
        <BrowserRouter>
          <Header
            navigationItems={this.props.navigationItems}
            userMenuItems={this.props.userMenuItems}
            userFullName={this.props.userFullName}
          ></Header>
          <Routes>
            {this.props.navigationItems.map(item => (
              <Route
                path={`/${item.path}`}
                element={
                  <item.component
                    userId={this.props.userId}
                    onNotifyEvent={this.props.onNotifyEvent}
                    onPageUpdateEvent={this.props.pageUpdateEvent}
                  />
                }
              />
            ))}
          </Routes>
        </BrowserRouter>
      </div>
    );
  }

  refresh(ref) {
    logInfo(`Refresh command for '${ref}' in 'App'`);
    if (ref === 'user-panel') {
      this.sideNavBarRef.current.refresh(ref);
    }
  }
}